import React from 'react'
import { Slot } from '@radix-ui/react-slot'

import { Access } from '@/entities/session'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

export const CreatePricingCampaign = ({
	location,
	scope,
	children,
}: {
	location: string
	scope: {
		optimizationGroupId?: string
		globalPcSetId?: string
		disableOptimizationGroups?: boolean
	}
	children: React.ReactNode
}) => {
	const { showModal } = useModals()

	const handleCreateNewPricingCampaign = () => {
		ampli.settingsPricingCampaignsCreatePcClick({
			location,
		})

		showModal('CREATE_PRICING_CAMPAIGN_MODAL', scope || {})
	}

	return (
		<Access
			permissions={
				scope.globalPcSetId
					? ['CREATE_GLOBAL_PRICING_CAMPAIGNS']
					: ['CREATE_PRICING_CAMPAIGNS']
			}
		>
			<Slot onClick={handleCreateNewPricingCampaign}>{children}</Slot>
		</Access>
	)
}
